export const isNull = (arg: any): boolean => arg === null;

export const isUndefined = (arg: any): boolean => typeof arg === 'undefined';

export const isArr = (arg: any): boolean =>
  !isNull(arg) && !isUndefined(arg) && Array.isArray
    ? Array.isArray(arg)
    : Object.prototype.toString.call(arg) === '[object Array]';

export const isObj = (arg: any): boolean =>
  arg instanceof Object && arg.constructor === Object;

export const isStr = (arg: any): boolean =>
  !isNull(arg) &&
  !isUndefined(arg) &&
  (typeof arg === 'string' || (arg as object).constructor === String);

export const isNum = (arg: any): boolean =>
  typeof arg === 'number' && isFinite(arg);

export const isBoolean = (arg: any): boolean =>
  !isNull(arg) &&
  !isUndefined(arg) &&
  (typeof arg === 'boolean' || (arg as object).constructor === Boolean);

export const isRegExp = (arg: any): boolean =>
  !isNull(arg) &&
  !isUndefined(arg) &&
  typeof arg === 'object' &&
  arg.constructor === RegExp;

export const isError = (arg: any): boolean =>
  arg instanceof Error && !isUndefined(arg.message);

export const isDate = (arg: any): boolean => arg instanceof Date;

export const isSymbol = (arg: any): boolean =>
  !isNull(arg) && !isUndefined(arg) && typeof arg === 'symbol';
